import React, { useState, useEffect } from "react";
import InventoryTable from "./InventoryTable";
import InventoryActions from "./InventoryActions";
import axios from "axios";
import Cookies from "js-cookie";

const MyInventory = ({
  searchQuery,
  statusFilter,
  searchTrigger,
  setTotalItems,
  totalItems
}) => {
  const token = Cookies.get("authToken");
  const officeCode = Cookies.get("officeCode");

  //   // 
  const [inventoryData, setInventoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [inventoryPerPage, setInventoryPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchInventory();
  }, [searchTrigger, statusFilter, currentPage, inventoryPerPage]);

  // ✅ Ensure fetchInventory is properly defined
  const fetchInventory = async () => {
        //     // 
    try {
      const response = await axios.post(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/inventory/detailed-search?page=${
          currentPage - 1
        }&size=${inventoryPerPage}`,
        {
          query: searchQuery.trim(),
          status: statusFilter,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
        }
      );
      const { content, totalElements, totalPages } = response.data; // ✅ API response destructuring

      setInventoryData(content);
      setTotalItems(totalElements);
      setTotalPages(totalPages); // ✅ Update pagination controls
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching inventory:", error);
      setTotalItems(0);
      setInventoryData([]); // ✅ Ensure it doesn't remain undefined
      setTotalPages(1); // ✅ Reset pages
    }finally {
      setIsLoading(false);
    }
  };

  // ✅ Fetch inventory when the component mounts
  // useEffect(() => {
  //   fetchInventory();
  // }, []);

  return (
    <InventoryTable
      inventoryData={inventoryData}
      fetchInventory={fetchInventory}
      isLoading={isLoading}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      inventoryPerPage={inventoryPerPage}
      setInventoryPerPage={setInventoryPerPage}
      totalItems={totalItems}
      totalPages={totalPages}
    />
  );
};

export default MyInventory;
